import React, { useMemo, forwardRef } from 'react';
import clsx from 'clsx';
import { Element, Icon } from '../../atoms';
import { ControlContext } from './context';
import { useFieldContext } from '../field/context';
import * as styles from './control.styles';

// TODO: Fix icon detection
const isIcon = (child) => {
  return React.isValidElement(child) && (child.type?._payload?.value === Icon || child.type === Icon);
};

/** @type {import(".").ControlType} */
const Control = forwardRef(({ className, children, gapless, ...props }, ref) => {
  const child = React.Children.toArray(children);
  const { status, disabled, ...rest } = useFieldContext(props);

  const firstChild = child[0];
  const lastChild = child[child.length - 1];

  const hasAddonLeft = isIcon(firstChild);
  const hasAddonRight = isIcon(lastChild);

  const contextValue = useMemo(() => {
    return { disabled, status };
  }, [disabled, status]);

  return (
    <ControlContext.Provider value={contextValue}>
      <Element
        ref={ref}
        as="div"
        className={clsx(styles.control, className, {
          [styles.variants.gapless]: gapless,
          [styles.variants.hasAddons]: hasAddonRight || hasAddonLeft,
          [styles.variants.right]: hasAddonRight,
          [styles.variants.left]: hasAddonLeft,
          [styles.variants[status]]: status,
        })}
        {...rest}
      >
        {children}
      </Element>
    </ControlContext.Provider>
  );
});

if (process.env.NODE_ENV !== 'production') {
  Control.displayName = 'Control';
}

export default Control;
